import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Calendar, Clock, ArrowRight, Search, Loader2 } from 'lucide-react';
import './BlogPage.css';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const BlogPage = () => {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    fetchBlogs();
  }, []);

  const fetchBlogs = async () => {
    try {
      const response = await fetch(`${API_URL}/api/blog`);
      if (response.ok) {
        const data = await response.json();
        setBlogs(data);
      }
    } catch (error) {
      console.error('Failed to fetch blogs:', error);
    } finally {
      setLoading(false);
    }
  };

  const filteredBlogs = blogs.filter(blog =>
    blog.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
    blog.excerpt?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const formatDate = (dateStr) => {
    if (!dateStr) return '';
    return new Date(dateStr).toLocaleDateString('en-IN', {
      day: 'numeric',
      month: 'long',
      year: 'numeric'
    });
  };

  return (
    <div className="blog-page" data-testid="blog-page">
      {/* Hero Section */}
      <section className="blog-hero">
        <div className="container">
          <span className="section-label">Our Blog</span>
          <h1 className="page-title">Insights & Stories</h1>
          <p className="page-subtitle">
            Tips, tutorials, and behind-the-scenes from the world of video editing
          </p>
        </div>
      </section>

      {/* Search */}
      <section className="blog-search-section">
        <div className="container">
          <div className="search-box">
            <Search size={20} />
            <input
              type="text"
              placeholder="Search articles..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              data-testid="blog-search"
            />
          </div>
        </div>
      </section>

      {/* Blog Grid */}
      <section className="blog-grid-section">
        <div className="container">
          {loading ? (
            <div className="loading-state">
              <Loader2 className="spin" size={40} />
              <p>Loading articles...</p>
            </div>
          ) : filteredBlogs.length === 0 ? (
            <div className="empty-state">
              <h3>No articles found</h3>
              <p>Check back soon for new content!</p>
            </div>
          ) : (
            <div className="blog-grid">
              {filteredBlogs.map((blog, index) => (
                <article 
                  key={blog.id} 
                  className={`blog-card ${index === 0 ? 'featured' : ''}`}
                  data-testid={`blog-card-${blog.id}`}
                >
                  <div className="blog-thumbnail">
                    <img src={blog.cover_image} alt={blog.title} />
                    {index === 0 && <span className="featured-badge">Featured</span>}
                  </div>
                  <div className="blog-content">
                    <div className="blog-meta">
                      <span className="blog-date">
                        <Calendar size={14} />
                        {formatDate(blog.publish_date)}
                      </span>
                    </div>
                    <h2 className="blog-title">{blog.title}</h2>
                    <p className="blog-excerpt">{blog.excerpt || blog.content?.substring(0, 150) + '...'}</p>
                    <Link to={`/blog/${blog.slug}`} className="read-more">
                      Read More <ArrowRight size={16} />
                    </Link>
                  </div>
                </article>
              ))}
            </div>
          )}
        </div>
      </section>
    </div>
  );
};

export default BlogPage;
